const pages = {
  id: 'pages',
  title: 'pages',
  type: 'group',

  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      icon: <i className="ph ph-house" />,
      url: '/dashboard',
      permission: 'dashboard_access',
      module: 'dashboard'
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      icon: <i className="ph ph-gear" />,
      url: '/settings',
      permission: ['settings_profile', 'settings_general'],
      module: 'settings'
    },
    {
      id: 'roles-permissions',
      title: 'Roles & Permissions',
      type: 'item',
      icon: <i className="ph ph-shield-check" />,
      url: '/roles-permissions',
      permission: 'role_permission_access',
      module: 'role_permission_management'
    },
    {
      id: 'restaurant',
      title: 'Locations',
      type: 'item',
      icon: <i className="ph ph-fork-knife" />,
      url: '/restaurant',
      permission: 'restaurant_listing',
      module: 'restaurant_management'
    },
    {
      id: 'user',
      title: 'User',
      type: 'item',
      icon: <i className="ph ph-user" />,
      url: '/users',
      permission: 'user_listing',
      module: 'user_management'
    },
    {
      id: 'facilities-preference',
      title: 'Facilities & Preferences',
      type: 'item',
      icon: <i className="ti ti-user-cog" />,
      url: '/facilities-preference',
      permission: 'preference_listing',
      module: 'preference_amenities'
    },
    {
      id: 'custom-setup',
      title: 'Custom setup',
      type: 'item',
      icon: <i className="ti ti-settings-plus" />,
      url: '/custom-setup',
      permission: 'custom_setup_listing',
      module: 'custom_setup'
    },
    {
      id: 'booking-management',
      title: 'Booking Management',
      type: 'item',
      icon: <i className="ph ph-calendar-check" />,
      url: '/booking-management',
      permission: 'booking_listing',
      module: 'booking_management'
    },
    {
      id: 'calendar',
      title: 'Calendar',
      type: 'item',
      icon: <i className="ph ph-calendar-check" />,
      url: '/calendar',
      module: 'calendar'
    },
    {
      id: 'giftcard',
      title: 'Gift Card',
      type: 'item',
      icon: <i className="ph ph-gift" />,
      url: '/gift_card',
      // Same permission the route already enforces (PagesRoutes.jsx), so the
      // nav entry can't advertise a page that would then refuse to open.
      permission: 'giftcard_listing',
      module: 'gift_cards'
    },
    {
      id: 'ticket',
      title: 'Ticket & Events',
      type: 'item',
      icon: <i className="ph ph-gift" />,
      url: '/ticket',
      // One nav entry, two tabs behind it — visible if either side is granted.
      permission: ['event_listing', 'ticket_listing'],
      module: ['events', 'tickets']
    },
    {
      id: 'vouchers',
      title: 'Vouchers',
      type: 'item',
      icon: <i className="ph ph-ticket" />,
      url: '/vouchers',
      // Two tabs behind one entry — in-house vouchers and public passes are
      // separate permissions, and VoucherContainer already falls back to
      // whichever tab the role can see, so either one should reveal the link.
      permission: ['voucher_listing', 'public_pass_listing'],
      module: 'vouchers'
    },
    {
      id: 'loyalty',
      title: 'Loyalty',
      type: 'item',
      icon: <i className="ph ph-medal" />,
      url: '/loyalty',
      // The same permission the route enforces, so the nav entry cannot
      // advertise a page that would then refuse to open.
      permission: 'loyalty_access',
      module: 'loyalty'
    },
    {
      id: 'menus',
      title: 'Menu',
      type: 'item',
      icon: <i className="ph ph-list-dashes" />,
      url: '/menus',
      permission: 'menu_listing',
      module: 'menus'
    },
    {
      id: 'pos-setup',
      title: 'POS Setup',
      type: 'item',
      icon: <i className="ph ph-storefront" />,
      url: '/pos-setup',
      permission: 'pos_setup',
      // Was 'pos_setup', which is not a row in the modules table — the module
      // is 'pos', so the gate never matched anything.
      module: 'pos'
    },
    {
      id: 'store-room',
      title: 'Pantry/Store Room',
      type: 'item',
      icon: <i className="ph ph-package" />,
      url: '/store-room',
      // Any of the four tabs is reason enough to show the link — the page falls
      // back to whichever tab the role can actually open.
      permission: ['store_room_access', 'stock_item_listing', 'vendor_listing', 'store_location_listing'],
      module: 'store_room'
    }
  ]
};

export default pages;
